<template>
  <div>
    <i18n class="mt-4"
          path="message.accountDeactivationForm.deactivate"
          tag="p">
      <b-link variant="link"
             place="deactivateLink"
             v-b-modal.modal1>
        {{ $t('message.accountDeactivationForm.deactivateLink') }}
      </b-link>
    </i18n>

    <b-modal id="modal1"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.accountDeactivationForm.title')"
             :ok-title="$t('message.accountDeactivationForm.btn.ok')"
             :cancel-title="$t('message.accountDeactivationForm.btn.cancel')"
             @ok="deactivate">
      <p class="mt-4">{{ $t('message.accountDeactivationForm.question') }}</p>
      <p class="mt-4">{{ $t('message.accountDeactivationForm.message') }}</p>
    </b-modal>
  </div>
</template>

<script>
  export default {
    methods: {
      deactivate () {
        this.onDeactivateFn()
      }
    },
    props: {
      onDeactivateFn: {
        type: Function,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/AccountDeactivationForm.vue